import { lazy } from 'react';

export const iconsMap = {
  /* Index */
  'icons/index/counter-general': lazy(
    () => import('../../../icons/index/counter-general.svg')
  ),
  /* User menu */
  'icons/user_menu/profile_desktop': lazy(
    () => import('../../../icons/user_menu/profile_desktop.svg')
  ),
  'icons/user_menu/profile_mobile': lazy(
    () => import('../../../icons/user_menu/profile_mobile.svg')
  ),
  'icons/user_menu/profile_VIP_desktop': lazy(
    () => import('../../../icons/user_menu/profile_VIP_desktop.svg')
  ),
  'icons/user_menu/vip_logo': lazy(
    () => import('../../../icons/user_menu/vip_logo.svg')
  ),
  'icons/user_menu/balance': lazy(
    () => import('../../../icons/user_menu/balance.svg')
  ),
  'icons/user_menu/bonuses': lazy(
    () => import('../../../icons/user_menu/bonuses.svg')
  ),
  'icons/user_menu/bets': lazy(
    () => import('../../../icons/user_menu/bets.svg')
  ),
  'icons/user_menu/club': lazy(
    () => import('../../../icons/user_menu/club.svg')
  ),
  'icons/user_menu/exit_ic': lazy(
    () => import('../../../icons/user_menu/exit_ic.svg')
  ),
  'icons/user_menu/messages': lazy(
    () => import('../../../icons/user_menu/messages.svg')
  ),
  'icons/user_menu/settings': lazy(
    () => import('../../../icons/user_menu/settings.svg')
  ),
  'icons/user_menu/promotions': lazy(
    () => import('../../../icons/user_menu/promotions.svg')
  ),
  'icons/user_menu/responsible': lazy(
    () => import('../../../icons/user_menu/responsible.svg')
  ),
  'icons/user_menu/support': lazy(
    () => import('../../../icons/user_menu/support.svg')
  ),
  'icons/user_menu/support_new': lazy(
    () => import('../../../icons/user_menu/support_new.svg')
  ),
  'icons/user_menu/support_ro': lazy(
    () => import('../../../icons/user_menu/support_ro.svg')
  ),
  'icons/user_menu/person_feedback': lazy(
    () => import('../../../icons/user_menu/person_feedback.svg')
  ),
  'icons/user_menu/support_24': lazy(
    () => import('../../../icons/user_menu/support_24.svg')
  ),
  'icons/user_menu/information': lazy(
    () => import('../../../icons/user_menu/information.svg')
  ),
  'icons/user_menu/footer/mail': lazy(
    () => import('../../../icons/user_menu/footer/mail.svg')
  ),
  'icons/user_menu/footer/chart': lazy(
    () => import('../../../icons/user_menu/footer/chat.svg')
  ),
  'icons/user_menu/footer/support': lazy(
    () => import('../../../icons/user_menu/footer/support.svg')
  ),
  'icons/user_menu/footer/viber': lazy(
    () => import('../../../icons/user_menu/footer/viber.svg')
  ),
  'icons/user_menu/footer/telegram': lazy(
    () => import('../../../icons/user_menu/footer/telegram.svg')
  ),
  'icons/user_menu/footer/android': lazy(
    () => import('../../../icons/user_menu/footer/android.svg')
  ),
  'icons/user_menu/footer/app-store': lazy(
    () => import('../../../icons/user_menu/footer/app-store.svg')
  ),
  /* State */
  'icons/general/state/loader': lazy(
    () => import('../../../icons/general/state/loader.svg')
  ),
  'icons/general/state/favorite-on': lazy(
    () => import('../../../icons/general/state/favorite-on.svg')
  ),
  'icons/general/state/favorite-off': lazy(
    () => import('../../../icons/general/state/favorite-off.svg')
  ),
  'icons/general/state/video': lazy(
    () => import('../../../icons/general/state/video.svg')
  ),
  'icons/general/state/video-free': lazy(
    () => import('../../../icons/general/state/video-free.svg')
  ),
  'icons/general/state/settings-default': lazy(
    () => import('../../../icons/general/state/settings-default.svg')
  ),
  'icons/general/state/notverified': lazy(
    () => import('../../../icons/general/state/notverified.svg')
  ),
  'icons/general/state/verified': lazy(
    () => import('../../../icons/general/state/verified.svg')
  ),
  'icons/general/state/in-process': lazy(
    () => import('../../../icons/general/state/in-process.svg')
  ),
  'icons/general/state/success': lazy(
    () => import('../../../icons/general/state/success.svg')
  ),
  'icons/general/state/canceled': lazy(
    () => import('../../../icons/general/state/canceled.svg')
  ),
  'icons/general/state/return': lazy(
    () => import('../../../icons/general/state/return.svg')
  ),
  'icons/general/state/blocked': lazy(
    () => import('../../../icons/general/state/blocked.svg')
  ),
  'icons/general/state/checkmark': lazy(
    () => import('../../../icons/general/state/checkmark.svg')
  ),
  'icons/general/state/pushpin-on': lazy(
    () => import('../../../icons/general/state/pushpin-on.svg')
  ),
  'icons/general/state/pushpin-off': lazy(
    () => import('../../../icons/general/state/pushpin-off.svg')
  ),
  'icons/general/state/show': lazy(
    () => import('../../../icons/general/state/show.svg')
  ),
  'icons/general/state/hide': lazy(
    () => import('../../../icons/general/state/hide.svg')
  ),
  'icons/general/state/in-progress': lazy(
    () => import('../../../icons/general/state/in-progress.svg')
  ),
  'icons/general/state/cashout': lazy(
    () => import('../../../icons/general/state/cashout.svg')
  ),
  'icons/general/state/beginner': lazy(
    () => import('../../../icons/general/state/beginner.svg')
  ),
  'icons/general/state/amateur': lazy(
    () => import('../../../icons/general/state/amateur.svg')
  ),
  'icons/general/state/master': lazy(
    () => import('../../../icons/general/state/master.svg')
  ),
  'icons/general/state/vip': lazy(
    () => import('../../../icons/general/state/vip.svg')
  ),
  'icons/general/state/warning': lazy(
    () => import('../../../icons/general/state/warning.svg')
  ),
  'icons/general/state/settings': lazy(
    () => import('../../../icons/general/state/settings.svg')
  ),
  'icons/general/state/line-buttons': lazy(
    () => import('../../../icons/general/state/line-buttons.svg')
  ),
  'icons/general/state/line-tables': lazy(
    () => import('../../../icons/general/state/line-tables.svg')
  ),
  'icons/general/state/stake-sum': lazy(
    () => import('../../../icons/general/state/stake-sum.svg')
  ),
  'icons/general/state/stake-sum1': lazy(
    () => import('../../../icons/general/state/stake-sum1.svg')
  ),
  'icons/general/state/seats4': lazy(
    () => import('../../../icons/general/state/seats4.svg')
  ),
  'icons/general/state/casino-hold': lazy(
    () => import('../../../icons/general/state/casino-hold.svg')
  ),
  'icons/general/state/ic-casino': lazy(
    () => import('../../../icons/general/state/ic_casino.svg')
  ),
  'icons/general/state/quantity-of-players': lazy(
    () => import('../../../icons/general/state/quantity-of-players.svg')
  ),
  'icons/general/state/info': lazy(
    () => import('../../../icons/general/state/info.svg')
  ),
  'icons/general/state/info2': lazy(
    () => import('../../../icons/general/state/info2.svg')
  ),
  'icons/general/state/will-end-in': lazy(
    () => import('../../../icons/general/state/will-end-in.svg')
  ),
  'icons/general/state/will-begin': lazy(
    () => import('../../../icons/general/state/will-begin.svg')
  ),
  'icons/general/state/news': lazy(
    () => import('../../../icons/general/state/news.svg')
  ),
  'icons/general/state/notification-bell': lazy(
    () => import('../../../icons/general/state/notification-bell.svg')
  ),
  'icons/general/color_scheme/dark': lazy(
    () => import('../../../icons/general/color_scheme/dark.svg')
  ),
  'icons/general/color_scheme/light': lazy(
    () => import('../../../icons/general/color_scheme/light.svg')
  ),
  'icons/general/color_scheme/auto': lazy(
    () => import('../../../icons/general/color_scheme/auto.svg')
  ),
  /* Nav */
  'icons/general/nav/arrow-up': lazy(
    () => import('../../../icons/general/nav/arrow-up.svg')
  ),
  'icons/general/nav/arrow-down': lazy(
    () => import('../../../icons/general/nav/arrow-down.svg')
  ),
  'icons/general/nav/dropdown-down': lazy(
    () => import('../../../icons/general/nav/dropdown-down.svg')
  ),
  'icons/general/nav/dropdown-up': lazy(
    () => import('../../../icons/general/nav/dropdown-up.svg')
  ),
  'icons/general/nav/expand': lazy(
    () => import('../../../icons/general/nav/expand.svg')
  ),
  'icons/general/nav/collapse': lazy(
    () => import('../../../icons/general/nav/collapse.svg')
  ),
  'icons/general/nav/back': lazy(
    () => import('../../../icons/general/nav/back.svg')
  ),
  'icons/general/nav/next': lazy(
    () => import('../../../icons/general/nav/next.svg')
  ),
  'icons/general/nav/ic_next': lazy(
    () => import('../../../icons/general/nav/ic_next.svg')
  ),
  'icons/general/nav/go-to': lazy(
    () => import('../../../icons/general/nav/go-to.svg')
  ),
  'icons/general/nav/go-to-circle': lazy(
    () => import('../../../icons/general/nav/go-to-circle.svg')
  ),
  'icons/general/nav/dropdown_down': lazy(
    () => import('../../../icons/general/nav/dropdown_down.svg')
  ),
  'icons/general/nav/arrow-checked': lazy(
    () => import('../../../icons/general/nav/arrow-checked.svg')
  ),
  'icons/general/nav/needHelp': lazy(
    () => import('../../../icons/general/nav/need_help.svg')
  ),
  'icons/general/nav/liveCalendar': lazy(
    () => import('../../../icons/general/nav/calendar.svg')
  ),
  'icons/general/nav/location': lazy(
    () => import('../../../icons/general/nav/location.svg')
  ),
  'icons/general/nav/up': lazy(
    () => import('../../../icons/general/nav/up.svg')
  ),
  'icons/general/nav/down': lazy(
    () => import('../../../icons/general/nav/down.svg')
  ),
  /* Action */
  'icons/general/action/receipt': lazy(
    () => import('../../../icons/general/action/receipt.svg')
  ),
  'icons/general/action/receipt_return': lazy(
    () => import('../../../icons/general/action/receipt_return.svg')
  ),
  /* Item */
  'icons/general/item/increased_coefficient': lazy(
    () => import('../../../icons/general/item/increased_coefficient.svg')
  ),
  'icons/general/action/close': lazy(
    () => import('../../../icons/general/action/close.svg')
  ),
  'icons/general/action/refresh': lazy(
    () => import('../../../icons/general/action/refresh.svg')
  ),
  'icons/general/action/search': lazy(
    () => import('../../../icons/general/action/search.svg')
  ),
  'icons/general/action/delete': lazy(
    () => import('../../../icons/general/action/delete.svg')
  ),
  'icons/general/action/move_to': lazy(
    () => import('../../../icons/general/action/move_to.svg')
  ),
  'icons/general/action/edit': lazy(
    () => import('../../../icons/general/action/edit.svg')
  ),
  'icons/general/action/create': lazy(
    () => import('../../../icons/general/action/create.svg')
  ),
  'icons/general/action/basket': lazy(
    () => import('../../../icons/general/action/basket.svg')
  ),
  'icons/general/action/plus': lazy(
    () => import('../../../icons/general/action/plus.svg')
  ),
  'icons/general/action/minus': lazy(
    () => import('../../../icons/general/action/minus.svg')
  ),
  'icons/general/action/done': lazy(
    () => import('../../../icons/general/action/done.svg')
  ),
  'icons/general/action/copy': lazy(
    () => import('../../../icons/general/action/copy.svg')
  ),
  'icons/general/action/ic_copy': lazy(
    () => import('../../../icons/general/action/ic_copy.svg')
  ),
  'icons/general/action/attach_file': lazy(
    () => import('../../../icons/general/action/attach_file.svg')
  ),
  'icons/general/action/photo': lazy(
    () => import('../../../icons/general/action/photo.svg')
  ),
  'icons/general/action/share': lazy(
    () => import('../../../icons/general/action/share.svg')
  ),
  'icons/general/action/live_chat': lazy(
    () => import('../../../icons/general/action/live_chat.svg')
  ),
  /* Item */
  'icons/general/item/calendar': lazy(
    () => import('../../../icons/general/item/calendar.svg')
  ),
  'icons/general/item/list': lazy(
    () => import('../../../icons/general/item/list.svg')
  ),
  'icons/general/item/corona': lazy(
    () => import('../../../icons/general/item/corona.svg')
  ),
  'icons/general/item/men': lazy(
    () => import('../../../icons/general/item/men.svg')
  ),
  'icons/general/item/woman': lazy(
    () => import('../../../icons/general/item/woman.svg')
  ),
  'icons/general/item/timer': lazy(
    () => import('../../../icons/general/item/timer.svg')
  ),
  'icons/general/item/clock': lazy(
    () => import('../../../icons/general/item/clock.svg')
  ),
  'icons/general/item/clock2': lazy(
    () => import('../../../icons/general/item/clock2.svg')
  ),
  'icons/general/item/clock-bets': lazy(
    () => import('../../../icons/general/item/clock-bets.svg')
  ),
  'icons/general/item/filter': lazy(
    () => import('../../../icons/general/item/filter.svg')
  ),
  'icons/general/item/sport_nc': lazy(
    () => import('../../../icons/general/item/sport_nc.svg')
  ),
  /* Alert */
  'icons/general/alert/error': lazy(
    () => import('../../../icons/general/alert/error.svg')
  ),
  'icons/general/alert/success': lazy(
    () => import('../../../icons/general/alert/success.svg')
  ),
  'icons/general/alert/info': lazy(
    () => import('../../../icons/general/alert/info.svg')
  ),
  /* Event */
  'icons/event/statistics': lazy(
    () => import('../../../icons/event/statistics.svg')
  ),
  'icons/event/neutral': lazy(() => import('../../../icons/event/neutral.svg')),
  'icons/event/penalty': lazy(() => import('../../../icons/event/penalty.svg')),
  'icons/event/corner': lazy(() => import('../../../icons/event/corner.svg')),
  'icons/event/yellow-card': lazy(
    () => import('../../../icons/event/yellow-card.svg')
  ),
  'icons/event/red-card': lazy(
    () => import('../../../icons/event/red-card.svg')
  ),
  'icons/event/scoreboard': lazy(
    () => import('../../../icons/event/scoreboard.svg')
  ),
  'icons/event/collapse-video': lazy(
    () => import('../../../icons/event/collapse-video.svg')
  ),
  'icons/event/expand-video': lazy(
    () => import('../../../icons/event/expand-video.svg')
  ),
  /* Sport */
  'icons/sport/default': lazy(() => import('../../../icons/sport/default.svg')),
  'icons/sport/id-1': lazy(() => import('../../../icons/sport/id-1.svg')),
  'icons/sport/id-2': lazy(() => import('../../../icons/sport/id-2.svg')),
  'icons/sport/id-3': lazy(() => import('../../../icons/sport/id-3.svg')),
  'icons/sport/id-4': lazy(() => import('../../../icons/sport/id-4.svg')),
  'icons/sport/id-5': lazy(() => import('../../../icons/sport/id-5.svg')),
  'icons/sport/id-6': lazy(() => import('../../../icons/sport/id-6.svg')),
  'icons/sport/id-7': lazy(() => import('../../../icons/sport/id-7.svg')),
  'icons/sport/id-8': lazy(() => import('../../../icons/sport/id-8.svg')),
  'icons/sport/id-9': lazy(() => import('../../../icons/sport/id-9.svg')),
  'icons/sport/id-10': lazy(() => import('../../../icons/sport/id-10.svg')),
  'icons/sport/id-11': lazy(() => import('../../../icons/sport/id-11.svg')),
  'icons/sport/id-12': lazy(() => import('../../../icons/sport/id-12.svg')),
  'icons/sport/id-13': lazy(() => import('../../../icons/sport/id-13.svg')),
  'icons/sport/id-14': lazy(() => import('../../../icons/sport/id-14.svg')),
  'icons/sport/id-15': lazy(() => import('../../../icons/sport/id-15.svg')),
  'icons/sport/id-16': lazy(() => import('../../../icons/sport/id-16.svg')),
  'icons/sport/id-17': lazy(() => import('../../../icons/sport/id-17.svg')),
  'icons/sport/id-18': lazy(() => import('../../../icons/sport/id-18.svg')),
  'icons/sport/id-19': lazy(() => import('../../../icons/sport/id-19.svg')),
  'icons/sport/id-20': lazy(() => import('../../../icons/sport/id-20.svg')),
  'icons/sport/id-21': lazy(() => import('../../../icons/sport/id-21.svg')),
  'icons/sport/id-22': lazy(() => import('../../../icons/sport/id-22.svg')),
  'icons/sport/id-23': lazy(() => import('../../../icons/sport/id-23.svg')),
  'icons/sport/id-24': lazy(() => import('../../../icons/sport/id-24.svg')),
  'icons/sport/id-25': lazy(() => import('../../../icons/sport/id-25.svg')),
  'icons/sport/id-26': lazy(() => import('../../../icons/sport/id-26.svg')),
  'icons/sport/id-27': lazy(() => import('../../../icons/sport/id-27.svg')),
  'icons/sport/id-28': lazy(() => import('../../../icons/sport/id-28.svg')),
  'icons/sport/id-29': lazy(() => import('../../../icons/sport/id-29.svg')),
  'icons/sport/id-30': lazy(() => import('../../../icons/sport/id-30.svg')),
  'icons/sport/id-31': lazy(() => import('../../../icons/sport/id-31.svg')),
  'icons/sport/id-32': lazy(() => import('../../../icons/sport/id-32.svg')),
  'icons/sport/id-33': lazy(() => import('../../../icons/sport/id-33.svg')),
  'icons/sport/id-34': lazy(() => import('../../../icons/sport/id-34.svg')),
  'icons/sport/id-35': lazy(() => import('../../../icons/sport/id-35.svg')),
  'icons/sport/id-36': lazy(() => import('../../../icons/sport/id-36.svg')),
  'icons/sport/id-37': lazy(() => import('../../../icons/sport/id-37.svg')),
  'icons/sport/id-38': lazy(() => import('../../../icons/sport/id-38.svg')),
  'icons/sport/id-39': lazy(() => import('../../../icons/sport/id-39.svg')),
  'icons/sport/id-40': lazy(() => import('../../../icons/sport/id-40.svg')),
  'icons/sport/id-41': lazy(() => import('../../../icons/sport/id-41.svg')),
  'icons/sport/id-42': lazy(() => import('../../../icons/sport/id-42.svg')),
  'icons/sport/id-43': lazy(() => import('../../../icons/sport/id-43.svg')),
  'icons/sport/id-44': lazy(() => import('../../../icons/sport/id-44.svg')),
  'icons/sport/id-45': lazy(() => import('../../../icons/sport/id-45.svg')),
  'icons/sport/id-46': lazy(() => import('../../../icons/sport/id-46.svg')),
  'icons/sport/id-47': lazy(() => import('../../../icons/sport/id-47.svg')),
  'icons/sport/id-48': lazy(() => import('../../../icons/sport/id-48.svg')),
  'icons/sport/id-49': lazy(() => import('../../../icons/sport/id-49.svg')),
  'icons/sport/id-50': lazy(() => import('../../../icons/sport/id-50.svg')),
  'icons/sport/id-51': lazy(() => import('../../../icons/sport/id-51.svg')),
  'icons/sport/id-52': lazy(() => import('../../../icons/sport/id-52.svg')),
  'icons/sport/id-53': lazy(() => import('../../../icons/sport/id-53.svg')),
  'icons/sport/id-54': lazy(() => import('../../../icons/sport/id-54.svg')),
  'icons/sport/id-55': lazy(() => import('../../../icons/sport/id-55.svg')),
  'icons/sport/id-56': lazy(() => import('../../../icons/sport/id-56.svg')),
  'icons/sport/id-57': lazy(() => import('../../../icons/sport/id-57.svg')),
  'icons/sport/id-58': lazy(() => import('../../../icons/sport/id-58.svg')),
  'icons/sport/id-59': lazy(() => import('../../../icons/sport/id-59.svg')),
  'icons/sport/id-60': lazy(() => import('../../../icons/sport/id-60.svg')),
  'icons/sport/id-61': lazy(() => import('../../../icons/sport/id-61.svg')),
  'icons/sport/id-62': lazy(() => import('../../../icons/sport/id-62.svg')),
  'icons/sport/id-63': lazy(() => import('../../../icons/sport/id-63.svg')),
  'icons/sport/id-64': lazy(() => import('../../../icons/sport/id-64.svg')),
  'icons/sport/id-65': lazy(() => import('../../../icons/sport/id-65.svg')),
  'icons/sport/id-66': lazy(() => import('../../../icons/sport/id-66.svg')),
  'icons/sport/id-68': lazy(() => import('../../../icons/sport/id-68.svg')),
  'icons/sport/id-71': lazy(() => import('../../../icons/sport/id-71.svg')),
  'icons/sport/id-72': lazy(() => import('../../../icons/sport/id-72.svg')),
  'icons/sport/id-73': lazy(() => import('../../../icons/sport/id-73.svg')),
  'icons/sport/id-74': lazy(() => import('../../../icons/sport/id-74.svg')),
  'icons/sport/id-75': lazy(() => import('../../../icons/sport/id-75.svg')),
  'icons/sport/id-76': lazy(() => import('../../../icons/sport/id-76.svg')),
  'icons/sport/id-77': lazy(() => import('../../../icons/sport/id-77.svg')),
  'icons/sport/id-78': lazy(() => import('../../../icons/sport/id-78.svg')),
  'icons/sport/id-79': lazy(() => import('../../../icons/sport/id-79.svg')),
  'icons/sport/id-80': lazy(() => import('../../../icons/sport/id-80.svg')),
  'icons/sport/id-81': lazy(() => import('../../../icons/sport/id-81.svg')),
  'icons/sport/id-84': lazy(() => import('../../../icons/sport/id-84.svg')),
  'icons/sport/id-85': lazy(() => import('../../../icons/sport/id-85.svg')),
  'icons/sport/id-86': lazy(() => import('../../../icons/sport/id-86.svg')),
  'icons/sport/id-87': lazy(() => import('../../../icons/sport/id-87.svg')),
  'icons/sport/id-89': lazy(() => import('../../../icons/sport/id-89.svg')),
  'icons/sport/id-90': lazy(() => import('../../../icons/sport/id-90.svg')),
  'icons/sport/id-91': lazy(() => import('../../../icons/sport/id-91.svg')),
  'icons/sport/id-92': lazy(() => import('../../../icons/sport/id-92.svg')),
  'icons/sport/id-93': lazy(() => import('../../../icons/sport/id-93.svg')),
  'icons/sport/id-95': lazy(() => import('../../../icons/sport/id-95.svg')),
  'icons/sport/id-96': lazy(() => import('../../../icons/sport/id-96.svg')),
  'icons/sport/id-99': lazy(() => import('../../../icons/sport/id-99.svg')),
  'icons/sport/id-100': lazy(() => import('../../../icons/sport/id-100.svg')),
  'icons/sport/id-132': lazy(() => import('../../../icons/sport/id-132.svg')),
  'icons/sport/id-165': lazy(() => import('../../../icons/sport/id-165.svg')),
  'icons/sport/id-167': lazy(() => import('../../../icons/sport/id-167.svg')),
  'icons/sport/id-168': lazy(() => import('../../../icons/sport/id-168.svg')),
  'icons/sport/id-169': lazy(() => import('../../../icons/sport/id-169.svg')),
  'icons/sport/id-171': lazy(() => import('../../../icons/sport/id-171.svg')),
  'icons/sport/id-172': lazy(() => import('../../../icons/sport/id-172.svg')),
  'icons/sport/id-173': lazy(() => import('../../../icons/sport/id-173.svg')),
  'icons/sport/id-175': lazy(() => import('../../../icons/sport/id-175.svg')),
  'icons/sport/id-176': lazy(() => import('../../../icons/sport/id-176.svg')),
  'icons/sport/id-177': lazy(() => import('../../../icons/sport/id-177.svg')),
  'icons/sport/id-178': lazy(() => import('../../../icons/sport/id-178.svg')),
  'icons/sport/id-179': lazy(() => import('../../../icons/sport/id-179.svg')),
  'icons/sport/id-180': lazy(() => import('../../../icons/sport/id-180.svg')),
  'icons/sport/id-181': lazy(() => import('../../../icons/sport/id-181.svg')),
  'icons/sport/id-182': lazy(() => import('../../../icons/sport/id-182.svg')),
  'icons/sport/id-183': lazy(() => import('../../../icons/sport/id-183.svg')),
  'icons/sport/id-184': lazy(() => import('../../../icons/sport/id-184.svg')),
  'icons/sport/id-185': lazy(() => import('../../../icons/sport/id-185.svg')),
  'icons/sport/id-186': lazy(() => import('../../../icons/sport/id-186.svg')),
  'icons/sport/id-187': lazy(() => import('../../../icons/sport/id-187.svg')),
  'icons/sport/id-188': lazy(() => import('../../../icons/sport/id-188.svg')),
  'icons/sport/id-191': lazy(() => import('../../../icons/sport/id-191.svg')),
  'icons/sport/id-192': lazy(() => import('../../../icons/sport/id-192.svg')),
  'icons/sport/id-193': lazy(() => import('../../../icons/sport/id-193.svg')),
  'icons/sport/id-194': lazy(() => import('../../../icons/sport/id-194.svg')),
  'icons/sport/id-195': lazy(() => import('../../../icons/sport/id-195.svg')),
  'icons/sport/id-196': lazy(() => import('../../../icons/sport/id-196.svg')),
  'icons/sport/id-197': lazy(() => import('../../../icons/sport/id-197.svg')),
  'icons/sport/id-230': lazy(() => import('../../../icons/sport/id-230.svg')),
  'icons/sport/id-231': lazy(() => import('../../../icons/sport/id-231.svg')),
  'icons/sport/id-232': lazy(() => import('../../../icons/sport/id-232.svg')),
  'icons/sport/id-233': lazy(() => import('../../../icons/sport/id-233.svg')),
  'icons/sport/id-234': lazy(() => import('../../../icons/sport/id-234.svg')),
  'icons/sport/id-235': lazy(() => import('../../../icons/sport/id-235.svg')),
  'icons/sport/id-236': lazy(() => import('../../../icons/sport/id-236.svg')),
  'icons/sport/id-241': lazy(() => import('../../../icons/sport/id-241.svg')),
  'icons/sport/id-240': lazy(() => import('../../../icons/sport/id-240.svg')),
  'icons/sport/id-239': lazy(() => import('../../../icons/sport/id-239.svg')),
  'icons/sport/id-238': lazy(() => import('../../../icons/sport/id-238.svg')),
  'icons/sport/id-237': lazy(() => import('../../../icons/sport/id-237.svg')),
  'icons/sport/id-1536': lazy(() => import('../../../icons/sport/id-1536.svg')),
  'icons/sport/id-1537': lazy(() => import('../../../icons/sport/id-1537.svg')),
  'icons/sport/id-1655': lazy(() => import('../../../icons/sport/id-1655.svg')),
  'icons/sport/id-1800': lazy(() => import('../../../icons/sport/id-1800.svg')),
  'icons/sport/id-33870': lazy(
    () => import('../../../icons/sport/id-33870.svg')
  ),
  'icons/sport/id-36267': lazy(
    () => import('../../../icons/sport/id-36267.svg')
  ),
  'icons/sport/id-36288': lazy(
    () => import('../../../icons/sport/id-36288.svg')
  ),
  'icons/sport/id-36293': lazy(
    () => import('../../../icons/sport/id-36293.svg')
  ),
  'icons/sport/id-36318': lazy(
    () => import('../../../icons/sport/id-36318.svg')
  ),
  'icons/sport/id-36335': lazy(
    () => import('../../../icons/sport/id-36335.svg')
  ),
  'icons/sport/id-36338': lazy(
    () => import('../../../icons/sport/id-36338.svg')
  ),
  'icons/sport/id-36459': lazy(
    () => import('../../../icons/sport/id-36459.svg')
  ),
  'icons/sport/id-36616': lazy(
    () => import('../../../icons/sport/id-36616.svg')
  ),
  'icons/sport/id-36698': lazy(
    () => import('../../../icons/sport/id-36698.svg')
  ),
  'icons/sport/id-36765': lazy(
    () => import('../../../icons/sport/id-36765.svg')
  ),
  'icons/sport/id-37014': lazy(
    () => import('../../../icons/sport/id-37014.svg')
  ),
  'icons/sport/id-37387': lazy(
    () => import('../../../icons/sport/id-37387.svg')
  ),
  'icons/sport/id-37876': lazy(
    () => import('../../../icons/sport/id-37876.svg')
  ),
  'icons/sport/id-37637': lazy(
    () => import('../../../icons/sport/id-37637.svg')
  ),
  'icons/sport/id-35422': lazy(
    () => import('../../../icons/sport/id-35422.svg')
  ),
  'icons/sport/id-38044': lazy(
    () => import('../../../icons/sport/id-38044.svg')
  ),
  /* Odd */
  'icons/odd/lock': lazy(() => import('../../../icons/odd/lock.svg')),
  'icons/odd/odd-up': lazy(() => import('../../../icons/odd/odd-up.svg')),
  'icons/odd/odd-down': lazy(() => import('../../../icons/odd/odd-down.svg')),
  /* Burger menu */
  'icons/nav_menu/betslip_default': lazy(
    () => import('../../../icons/nav_menu/betslip_default.svg')
  ),
  'icons/nav_menu/goToOld': lazy(
    () => import('../../../icons/nav_menu/goToOld.svg')
  ),
  'icons/nav_menu/results': lazy(
    () => import('../../../icons/nav_menu/results.svg')
  ),
  'icons/nav_menu/betGames': lazy(
    () => import('../../../icons/nav_menu/betGames.svg')
  ),
  'icons/nav_menu/casino': lazy(
    () => import('../../../icons/nav_menu/casino.svg')
  ),
  'icons/nav_menu/casinoLive': lazy(
    () => import('../../../icons/nav_menu/casinoLive.svg')
  ),
  'icons/nav_menu/cybersport': lazy(
    () => import('../../../icons/nav_menu/cybersport.svg')
  ),
  'icons/nav_menu/live': lazy(() => import('../../../icons/nav_menu/live.svg')),
  'icons/nav_menu/lotteries': lazy(
    () => import('../../../icons/nav_menu/lotteries.svg')
  ),
  'icons/nav_menu/promo': lazy(
    () => import('../../../icons/nav_menu/promo.svg')
  ),
  'icons/nav_menu/sports': lazy(
    () => import('../../../icons/nav_menu/sports.svg')
  ),
  'icons/nav_menu/tvBet': lazy(
    () => import('../../../icons/nav_menu/tvBet.svg')
  ),
  'icons/nav_menu/virtuals': lazy(
    () => import('../../../icons/nav_menu/virtuals.svg')
  ),
  'icons/nav_menu/aviator': lazy(
    () => import('../../../icons/nav_menu/aviator.svg')
  ),
  'icons/nav_menu/keno': lazy(() => import('../../../icons/nav_menu/keno.svg')),
  'icons/nav_menu/menu': lazy(() => import('../../../icons/nav_menu/menu.svg')),
  'icons/nav_menu/euro': lazy(() => import('../../../icons/nav_menu/euro.svg')),
  'icons/nav_menu/goldenRace': lazy(
    () => import('../../../icons/nav_menu/goldenRace.svg')
  ),
  'icons/nav_menu/quiz': lazy(() => import('../../../icons/nav_menu/quiz.svg')),
  'icons/nav_menu/instantGames': lazy(
    () => import('../../../icons/nav_menu/instantGames.svg')
  ),
  'icons/nav_menu/euro2020': lazy(
    () => import('../../../icons/nav_menu/euro2020.svg')
  ),
  'icons/nav_menu/promos': lazy(
    () => import('../../../icons/nav_menu/promos.svg')
  ),
  'icons/nav_menu/navMenu': lazy(
    () => import('../../../icons/nav_menu/navMenu.svg')
  ),
  'icons/nav_menu/twainSport': lazy(
    () => import('../../../icons/nav_menu/twainSport.svg')
  ),
  'icons/nav_menu/menuClose': lazy(
    () => import('../../../icons/nav_menu/menuClose.svg')
  ),
  'icons/nav_menu/promotions': lazy(
    () => import('../../../icons/nav_menu/promotions.svg')
  ),
  'icons/nav_menu/bonuses': lazy(
    () => import('../../../icons/nav_menu/bonuses.svg')
  ),
  'icons/nav_menu/tournaments': lazy(
    () => import('../../../icons/nav_menu/tournaments.svg')
  ),
  'icons/nav_menu/widget': lazy(
    () => import('../../../icons/nav_menu/widget.svg')
  ),
  'icons/nav_menu/bookOfSix': lazy(
    () => import('../../../icons/nav_menu/book_of_six.svg')
  ),
  'icons/general/action/upload': lazy(
    () => import('../../../icons/general/action/upload.svg')
  ),
  /* Predictions */
  'icons/predictions/predictionsInfoBlockIconActive': lazy(
    () =>
      import('../../../icons/predictions/predictionsInfoBlockIconActive.svg')
  ),
  'icons/predictions/predictionsInfoBlockIconChecked': lazy(
    () =>
      import('../../../icons/predictions/predictionsInfoBlockIconChecked.svg')
  ),
  'icons/predictions/predictionsInfoBlockIconEmpty': lazy(
    () => import('../../../icons/predictions/predictionsInfoBlockIconEmpty.svg')
  ),
  'icons/predictions/predictionsInfoBlockIconFailed': lazy(
    () =>
      import('../../../icons/predictions/predictionsInfoBlockIconFailed.svg')
  ),
  'icons/general/nav/microphone': lazy(
    () => import('../../../icons/general/nav/microphone.svg')
  ),
  'icons/general/nav/microphone_loader': lazy(
    () => import('../../../icons/general/nav/microphone_loader.svg')
  ),
  'icons/assistant/assistant_microphone_disabled': lazy(
    () => import('../../../icons/assistant/assistant_microphone_disabled.svg')
  ),
  'icons/assistant/assistant_microphone_enabled': lazy(
    () => import('../../../icons/assistant/assistant_microphone_enabled.svg')
  ),
  'icons/nav_menu/assistant': lazy(
    () => import('../../../icons/nav_menu/assistant.svg')
  ),
  /* Baseball bases */
  'icons/baseball-bases/000': lazy(
    () => import('../../../icons/baseball-bases/000.svg')
  ),
  'icons/baseball-bases/001': lazy(
    () => import('../../../icons/baseball-bases/001.svg')
  ),
  'icons/baseball-bases/010': lazy(
    () => import('../../../icons/baseball-bases/010.svg')
  ),
  'icons/baseball-bases/011': lazy(
    () => import('../../../icons/baseball-bases/011.svg')
  ),
  'icons/baseball-bases/100': lazy(
    () => import('../../../icons/baseball-bases/100.svg')
  ),
  'icons/baseball-bases/101': lazy(
    () => import('../../../icons/baseball-bases/101.svg')
  ),
  'icons/baseball-bases/110': lazy(
    () => import('../../../icons/baseball-bases/110.svg')
  ),
  'icons/baseball-bases/111': lazy(
    () => import('../../../icons/baseball-bases/111.svg')
  ),
  /* Pandascore */
  'icons/pandascore/general-stats': lazy(
    () => import('../../../icons/pandascore/general-stats.svg')
  ),
  'icons/pandascore/head-to-head': lazy(
    () => import('../../../icons/pandascore/head-to-head.svg')
  ),
  'icons/pandascore/form-guide': lazy(
    () => import('../../../icons/pandascore/form-guide.svg')
  ),
  'icons/pandascore/team-stats': lazy(
    () => import('../../../icons/pandascore/team-stats.svg')
  ),
  'icons/pandascore/player-stats': lazy(
    () => import('../../../icons/pandascore/player-stats.svg')
  ),
  /* Casino */
  'icons/casino/item/jackpot': lazy(
    () => import('../../../icons/casino/item/jackpot.svg')
  ),
  'icons/help/supportCircle': lazy(
    () => import('../../../icons/help/supportCircle.svg')
  ),
  'icons/casino/item/fruits': lazy(
    () => import('../../../icons/casino/item/fruits.svg')
  ),
  /* Bonuses */
  'icons/bonuses/bonussystem-background': lazy(
    () => import('../../../icons/bonuses/bonussystem-background.svg')
  ),
  'icons/bonuses/funds-background': lazy(
    () => import('../../../icons/bonuses/funds-background.svg')
  ),
  'icons/bonuses/default-background': lazy(
    () => import('../../../icons/bonuses/default-background.svg')
  ),
  'icons/bonuses/freespin-background': lazy(
    () => import('../../../icons/bonuses/freespin-background.svg')
  ),
  'icons/bonuses/cashback-background': lazy(
    () => import('../../../icons/bonuses/cashback-background.svg')
  )
};

export type IconsMap = typeof iconsMap;
